module.exports = ".clipboard-body {\n  height: 600px;\n  width: 1000px;\n  overflow-y: auto;\n}\n.overlay {\n  z-index: 160;\n}\n.btn.btn-primary:disabled {\n  background-color: #e4dede;\n  color: black;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/word-cloud-rawtext-popup/word-cloud-rawtext-popup.component.less
// module id = ./src/app/shared/components/word-cloud-rawtext-popup/word-cloud-rawtext-popup.component.less
// module chunks = main